/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sponsor_page: NonNullable<unknown>, "sponsor page": NonNullable<unknown> }} Earth_Day_2025_Partner_ContentInputs */

const en_earth_day_2025_partner_content = /** @type {(inputs: Earth_Day_2025_Partner_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your Forest Power is already sprouting in Africa. See the impact on Trees for the Future’s ${i?.sponsor_page}.`)
};

const ar_earth_day_2025_partner_content = /** @type {(inputs: Earth_Day_2025_Partner_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`قوة Forest الخاصة بك تنبت بالفعل في أفريقيا. شاهد التأثير على أشجار من أجل المستقبل ${i?.["sponsor page"]}.`)
};

const de_earth_day_2025_partner_content = /** @type {(inputs: Earth_Day_2025_Partner_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ihre Forest Power sprießt bereits in Afrika. Sehen Sie den Einfluss auf Trees for the Future’s ${i?.sponsor_page}.`)
};

const es_earth_day_2025_partner_content = /** @type {(inputs: Earth_Day_2025_Partner_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El poder de tu bosque ya está germinando en África. Mira el impacto en el ${i?.sponsor_page} de Árboles para el Futuro.`)
};

const fr_earth_day_2025_partner_content = /** @type {(inputs: Earth_Day_2025_Partner_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre Pouvoir Forest est déjà en train de germer en Afrique. Découvrez l'impact sur la page ${i?.sponsor_page} de Trees for the Future.`)
};

const it_earth_day_2025_partner_content = /** @type {(inputs: Earth_Day_2025_Partner_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il tuo Forest Power sta già germogliando in Africa. Visualizza l'impatto sul ${i?.["sponsor page"]} di Trees for the Future.`)
};

const ja_earth_day_2025_partner_content = /** @type {(inputs: Earth_Day_2025_Partner_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`あなたのForestパワーはすでにアフリカで芽吹いています。Trees for the Futureの${i?.sponsor_page}で成果をご覧ください。`)
};

const ko_earth_day_2025_partner_content = /** @type {(inputs: Earth_Day_2025_Partner_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`나의 Forest Power가 벌써 아프리카에서 피어나고 있어요. Trees for the Future ${i?.sponsor_page}에서 영향력을 확인하세요.`)
};

const pt_br_earth_day_2025_partner_content = /** @type {(inputs: Earth_Day_2025_Partner_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seu Poder do Forest já está germinando na África. Confira o impacto no ${i?.sponsor_page} da Trees for the Future.`)
};

const ru_earth_day_2025_partner_content = /** @type {(inputs: Earth_Day_2025_Partner_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ваша сила Forest уже прорастает в Африке. Проверьте вклад на странице Trees for the Future, ${i?.sponsor_page}.`)
};

const th_earth_day_2025_partner_content = /** @type {(inputs: Earth_Day_2025_Partner_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`พลังแห่ง Forest ของคุณได้เบ่งบานแล้วในทวีปแอฟริกา ดูผลกระทบต่อ Trees for the Future ${i?.sponsor_page}`)
};

const tr_earth_day_2025_partner_content = /** @type {(inputs: Earth_Day_2025_Partner_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Forest gücün Afrika'da filizlenmeye başladı. Etkisini Trees for the Future'ın ${i?.sponsor_page}'inde gör.`)
};

const zh_cn_earth_day_2025_partner_content = /** @type {(inputs: Earth_Day_2025_Partner_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`森林能量正悄悄在非洲发芽！前往 Trees for the Future 的${i?.sponsor_page}，了解更多植树成果。`)
};

const zh_tw_earth_day_2025_partner_content = /** @type {(inputs: Earth_Day_2025_Partner_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`森林能量正悄悄在非洲發芽！前往 Trees for the Future 的${i?.sponsor_page}，了解更多植樹成果。`)
};

/**
* | output |
* | --- |
* | "Your Forest Power is already sprouting in Africa. See the impact on Trees for the Future’s {sponsor_page}." |
*
* @param {Earth_Day_2025_Partner_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_partner_content = /** @type {((inputs: Earth_Day_2025_Partner_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Partner_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_partner_content(inputs)
	if (locale === "ar") return ar_earth_day_2025_partner_content(inputs)
	if (locale === "de") return de_earth_day_2025_partner_content(inputs)
	if (locale === "es") return es_earth_day_2025_partner_content(inputs)
	if (locale === "fr") return fr_earth_day_2025_partner_content(inputs)
	if (locale === "it") return it_earth_day_2025_partner_content(inputs)
	if (locale === "ja") return ja_earth_day_2025_partner_content(inputs)
	if (locale === "ko") return ko_earth_day_2025_partner_content(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_partner_content(inputs)
	if (locale === "ru") return ru_earth_day_2025_partner_content(inputs)
	if (locale === "th") return th_earth_day_2025_partner_content(inputs)
	if (locale === "tr") return tr_earth_day_2025_partner_content(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_partner_content(inputs)
	return zh_tw_earth_day_2025_partner_content(inputs)
});